import { useEffect } from "react";
import "./index.scss";

const Loading = () => {
  return (
    <section className="loading-line">
      <div></div>
    </section>
  );
};
export default Loading;
